<template>
  <div class="">
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">
            Overview of the Audits in Your Organization
          </h4>
          <ul id="pills-tab" class="nav nav-pills custom-pills owm" role="tablist">
            <li class="nav-item">
              <a id="pills-home-tab" class="nav-link active" data-toggle="pill" href="#users" role="tab" aria-selected="true">
                <span class="text-muted">No. of Audits Performed</span>
                <h3 class="m-b-0 text-dark"># {{ overview.total }}</h3>
              </a>
            </li>
            <li class="nav-item">
              <a id="pills-profile-tab" class="nav-link" data-toggle="pill" href="#revenue" role="tab" aria-selected="false">
                <span class="text-muted">No. of Audits Requested</span>
                <h3 class="m-b-0 text-dark"># {{ overview.total_my_audits }}</h3>
              </a>
            </li>
          </ul>
          <div id="pills-tabContent" class="tab-content">
            <div id="users" class="tab-pane fade show active" role="tabpanel" aria-labelledby="pills-home-tab">
              <div class="m-t-30 overview1 c3">
                <div class="c3-tooltip-container">
                  <div class="card-body">
                    <div class="row m-t-10">
                      <!-- col -->
                      <div class="col-md-6 col-sm-12 col-lg-4">
                        <div class="d-flex align-items-center">
                          <div class="m-r-10">
                            <span class="text-orange display-5"><i class="mdi mdi-clipboard-outline" /></span>
                          </div>
                          <div>
                            <span class="text-muted">Pending</span>
                            <h3 class="font-medium m-b-0">
                              {{ overview.total_pending }}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <!-- col -->
                      <!-- col -->
                      <div class="col-md-6 col-sm-12 col-lg-4">
                        <div class="d-flex align-items-center">
                          <div class="m-r-10">
                            <span class="text-primary display-5"><i class="mdi mdi-clipboard-text" /></span>
                          </div>
                          <div>
                            <span class="text-muted">In Progress</span>
                            <h3 class="font-medium m-b-0">
                              {{ overview.total_in_progress }}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <!-- col -->
                      <!-- col -->
                      <div class="col-md-6 col-sm-12 col-lg-4">
                        <div class="d-flex align-items-center">
                          <div class="m-r-10">
                            <span class="display-5"><i class="mdi mdi-clipboard-check" /></span>
                          </div>
                          <div>
                            <span class="text-muted">Completed</span>
                            <h3 class="font-medium m-b-0">
                              {{ overview.total_completed }}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <!-- col -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="revenue" class="tab-pane fade" role="tabpanel" aria-labelledby="pills-profile-tab">
              <div class="m-t-30 overview1 c3">
                <div class="c3-tooltip-container">
                  <div class="card-body">
                    <div class="row m-t-10">
                      <!-- col -->
                      <div class="col-md-6 col-sm-12 col-lg-4">
                        <div class="d-flex align-items-center">
                          <div class="m-r-10">
                            <span class="text-orange display-5"><i class="mdi mdi-clipboard-outline" /></span>
                          </div>
                          <div>
                            <span class="text-muted">Pending</span>
                            <h3 class="font-medium m-b-0">
                              {{ overview.total_my_pending }}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <!-- col -->
                      <!-- col -->
                      <div class="col-md-6 col-sm-12 col-lg-4">
                        <div class="d-flex align-items-center">
                          <div class="m-r-10">
                            <span class="text-primary display-5"><i class="mdi mdi-clipboard-text" /></span>
                          </div>
                          <div>
                            <span class="text-muted">In Progress</span>
                            <h3 class="font-medium m-b-0">
                              {{ overview.total_my_in_progress }}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <!-- col -->
                      <!-- col -->
                      <div class="col-md-6 col-sm-12 col-lg-4">
                        <div class="d-flex align-items-center">
                          <div class="m-r-10">
                            <span class="display-5"><i class="mdi mdi-clipboard-check" /></span>
                          </div>
                          <div>
                            <span class="text-muted">Completed</span>
                            <h3 class="font-medium m-b-0">
                              {{ overview.total_my_completed }}
                            </h3>
                          </div>
                        </div>
                      </div>
                      <!-- col -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Coop',
  components: {},
  data () {
    return {
      overview: {
        total: 0,
        total_pending: 0,
        total_in_progress: 0,
        total_completed: 0,
        total_my_audits: 0,
        total_my_pending: 0,
        total_my_in_progress: 0,
        total_my_completed: 0
      }
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      await Promise.all([
        this.getMyAudits(),
        this.getRequestedAudits()
      ])
    },
    async getMyAudits () {
      try {
        const reply = await this.$api.get('/audits/by_creator')
        this.overview.total_my_audits = reply.data.length
        this.overview.total_my_in_progress = reply.data.filter(a => a.status === 'InProgress').length
        this.overview.total_my_pending = reply.data.filter(a => a.status !== 'Completed').length
        this.overview.total_my_completed = reply.data.filter(a => a.status === 'Completed').length
      } catch (e) {
        console.error(e)
      }
    },
    async getRequestedAudits () {
      try {
        let reply = await this.$api.get('/audits/by_auditor')
        if (reply.data.length === 0) {
          reply = await this.$api.get('/audits/by_auditing_org')
        }
        this.overview.total = reply.data.length
        this.overview.total_in_progress = reply.data.filter(a => a.status === 'InProgress').length
        this.overview.total_pending = reply.data.filter(a => a.status !== 'Completed').length
        this.overview.total_completed = reply.data.filter(a => a.status === 'Completed').length
      } catch (e) {
        console.error(e)
      }
    },
    async getOverview () {
      try {
        const { data } = await this.$api.get('/audits/overview')
        this.overview = data
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped>
</style>
